var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMessageBubble = function SvgIconMessageBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.004 12a9 9 0 0 1-9 9h-9s1.56-3.744.936-5a9 9 0 1 1 17.064-4Z",
    "data-no-fill": "true",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconMessageBubble as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPHBhdGggZD0iTTIxLjAwMzkgMTJDMjEuMDAzOSAxNi45NzA2IDE2Ljk3NDUgMjEgMTIuMDAzOSAyMUM5Ljk2NzUgMjEgMy4wMDQ2MyAyMSAzLjAwNDYzIDIxQzMuMDA0NjMgMjEgNC41NjM4MiAxNy4yNTYxIDMuOTM5ODIgMTYuMDAwOEMzLjM0MDc2IDE0Ljc5NTYgMy4wMDM5MSAxMy40MzcyIDMuMDAzOTEgMTJDMy4wMDM5MSA3LjAyOTQ0IDcuMDMzMzQgMyAxMi4wMDM5IDNDMTYuOTc0NSAzIDIxLjAwMzkgNy4wMjk0NCAyMS4wMDM5IDEyWiINCiAgICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg==";